const MemoryLevel = {
  All: 0,
  parina: 1,
  motamuti_pari: 2,
  memorized: 3,
};
export default MemoryLevel;
